import { BffApiClientMolecule } from "@/app/api-client/store"
import { BlockchainFiltersMoleculeReatom } from "@/app/blockchains/filters/blockchain-filters-molecule.reatom"
import { getNftCountQueryParams } from "@/app/nft/counter/utils"
import { reatomQuery } from "@/app/reatom/reatom-query"
import { computed } from "@reatom/core"
import { molecule } from "bunshi"
import { ProfileMoleculeReatom as ProfileMolecule } from "../../store/index.reatom"

export const ProfileNftsCountMoleculeReatom = molecule((mol) => {
  const bffApiClient = mol(BffApiClientMolecule)
  const { walletAddress } = mol(ProfileMolecule)
  const { blockchainsQueryFilter } = mol(BlockchainFiltersMoleculeReatom)

  // Create query params that depend on blockchainsQueryFilter
  const queryParamsAtom = computed(() => {
    const blockchains = blockchainsQueryFilter()
    return getNftCountQueryParams(bffApiClient, {
      owner: walletAddress,
      blockchains,
    })
  }, "profileNftsCountQueryParams")

  // Get static query params for the reatomQuery
  const staticQueryParams = getNftCountQueryParams(bffApiClient, {
    owner: walletAddress,
    blockchains: [], // Will be overridden by useSuspenseQuery
  })

  const counter = reatomQuery<number>(staticQueryParams, "profileNftsCounter")

  return {
    counter,
    queryParamsAtom,
  }
})
